export enum TradeStatus {
  NoVoyage = 1,
  InVoyage = 2,
}
